import { useSelector, useDispatch } from 'react-redux';
import { selectLoaders } from '../sagas/selectors';
import { loadersActions } from '../sagas/base/loaders';

const useLoaderSelector = (actionType) => {
    const loaders = useSelector(selectLoaders);
    const dispatch = useDispatch();

    // Check that we have an actionType
    if (actionType in loaders) {
        return [
            loaders[actionType],
            () => dispatch(loadersActions.remove(actionType)),
            () => dispatch(loadersActions.reset())
        ];
    }

    // Return empty
    return [null, () => { }, () => { }];
};

export default useLoaderSelector;
